import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5a0ff65c = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _2b4c10f8 = () => interopDefault(import('../../../pages/confirm-interest.vue' /* webpackChunkName: "pages/confirm-interest" */))
const _5a3cf960 = () => interopDefault(import('../../../pages/marine-model-gallery.vue' /* webpackChunkName: "pages/marine-model-gallery" */))
const _5f6bf63a = () => interopDefault(import('../../../pages/model-home-grand-opening.vue' /* webpackChunkName: "pages/model-home-grand-opening" */))
const _3aec1458 = () => interopDefault(import('../../../pages/model-home-grand-opening-thankyou.vue' /* webpackChunkName: "pages/model-home-grand-opening-thankyou" */))
const _dd5c04f8 = () => interopDefault(import('../../../pages/presentationvideo.vue' /* webpackChunkName: "pages/presentationvideo" */))
const _713832c3 = () => interopDefault(import('../../../pages/riversedge-confirm-interest.vue' /* webpackChunkName: "pages/riversedge-confirm-interest" */))
const _27b28f08 = () => interopDefault(import('../../../pages/riversedge-confirm-interest-agents.vue' /* webpackChunkName: "pages/riversedge-confirm-interest-agents" */))
const _5a099fd6 = () => interopDefault(import('../../../pages/riversedge-confirm-interest-fernbrook.vue' /* webpackChunkName: "pages/riversedge-confirm-interest-fernbrook" */))
const _1a167aa3 = () => interopDefault(import('../../../pages/staging-index.vue' /* webpackChunkName: "pages/staging-index" */))
const _3c1feee2 = () => interopDefault(import('../../../pages/thankyou.vue' /* webpackChunkName: "pages/thankyou" */))
const _85801ef4 = () => interopDefault(import('../../../pages/thankyou-for-confirming-interest.vue' /* webpackChunkName: "pages/thankyou-for-confirming-interest" */))
const _574b0f24 = () => interopDefault(import('../../../pages/thankyou-for-confirming-interest-broker-info-session.vue' /* webpackChunkName: "pages/thankyou-for-confirming-interest-broker-info-session" */))
const _002f9215 = () => interopDefault(import('../../../pages/thankyou-grand-opening-fall-fair.vue' /* webpackChunkName: "pages/thankyou-grand-opening-fall-fair" */))
const _78e7b9c6 = () => interopDefault(import('../../../pages/blog/post-item-3.vue' /* webpackChunkName: "pages/blog/post-item-3" */))
const _78f5d147 = () => interopDefault(import('../../../pages/blog/post-item-4.vue' /* webpackChunkName: "pages/blog/post-item-4" */))
const _6f7708e5 = () => interopDefault(import('../../../pages/blog/reasons-to-buy-in-wasaga-beach.vue' /* webpackChunkName: "pages/blog/reasons-to-buy-in-wasaga-beach" */))
const _717c53bc = () => interopDefault(import('../../../pages/blog/set-your-sights-on-the-marine-model-home.vue' /* webpackChunkName: "pages/blog/set-your-sights-on-the-marine-model-home" */))
const _377f1991 = () => interopDefault(import('../../../pages/blog/top-things-to-do-in-wasaga-this-winter.vue' /* webpackChunkName: "pages/blog/top-things-to-do-in-wasaga-this-winter" */))
const _2c49c8b5 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _5a0ff65c,
    name: "blog"
  }, {
    path: "/confirm-interest",
    component: _2b4c10f8,
    name: "confirm-interest"
  }, {
    path: "/marine-model-gallery",
    component: _5a3cf960,
    name: "marine-model-gallery"
  }, {
    path: "/model-home-grand-opening",
    component: _5f6bf63a,
    name: "model-home-grand-opening"
  }, {
    path: "/model-home-grand-opening-thankyou",
    component: _3aec1458,
    name: "model-home-grand-opening-thankyou"
  }, {
    path: "/presentationvideo",
    component: _dd5c04f8,
    name: "presentationvideo"
  }, {
    path: "/riversedge-confirm-interest",
    component: _713832c3,
    name: "riversedge-confirm-interest"
  }, {
    path: "/riversedge-confirm-interest-agents",
    component: _27b28f08,
    name: "riversedge-confirm-interest-agents"
  }, {
    path: "/riversedge-confirm-interest-fernbrook",
    component: _5a099fd6,
    name: "riversedge-confirm-interest-fernbrook"
  }, {
    path: "/staging-index",
    component: _1a167aa3,
    name: "staging"
  }, {
    path: "/thankyou",
    component: _3c1feee2,
    name: "thankyou"
  }, {
    path: "/thankyou-for-confirming-interest",
    component: _85801ef4,
    name: "thankyou-for-confirming-interest"
  }, {
    path: "/thankyou-for-confirming-interest-broker-info-session",
    component: _574b0f24,
    name: "thankyou-for-confirming-interest-broker-info-session"
  }, {
    path: "/thankyou-grand-opening-fall-fair",
    component: _002f9215,
    name: "thankyou-grand-opening-fall-fair"
  }, {
    path: "/blog/post-item-3",
    component: _78e7b9c6,
    name: "blog-post-item-3"
  }, {
    path: "/blog/post-item-4",
    component: _78f5d147,
    name: "blog-post-item-4"
  }, {
    path: "/blog/reasons-to-buy-in-wasaga-beach",
    component: _6f7708e5,
    name: "blog-reasons-to-buy-in-wasaga-beach"
  }, {
    path: "/blog/set-your-sights-on-the-marine-model-home",
    component: _717c53bc,
    name: "blog-set-your-sights-on-the-marine-model-home"
  }, {
    path: "/blog/top-things-to-do-in-wasaga-this-winter",
    component: _377f1991,
    name: "blog-top-things-to-do-in-wasaga-this-winter"
  }, {
    path: "/",
    component: _2c49c8b5,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
